import React from 'react';
import { FormControlLabel, Checkbox, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

export function SettingCMMSForm({ control }) {
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2 ">ตั้งค่าอแชบอร์ด</div>
      <div className="w-1/2 py-2 px-2">
        <div className="flex flex-col w-full">
          <Controller
            control={control}
            name="setting.ims.display.purchase_date"
            render={({ field }) => (
              <FormControlLabel
                {...field}
                control={<Checkbox defaultChecked={field.value} />}
                label="วันที่ซื้อวัสดุ"
              />
            )}
          />
          <Controller
            control={control}
            name="setting.ims.display.lot_number"
            render={({ field }) => (
              <FormControlLabel
                {...field}
                control={<Checkbox defaultChecked={field.value} />}
                label="หมายเลขล็อต"
              />
            )}
          />
          <Controller
            control={control}
            name="setting.ims.display.cost"
            render={({ field }) => (
              <FormControlLabel
                {...field}
                control={<Checkbox defaultChecked={field.value} />}
                label="ราคาวัสดุ"
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

SettingCMMSForm.propTypes = {
  control: PropTypes.object,
};

export default SettingCMMSForm;
